import { useState } from 'react';
import { HostBackend } from '../../Routes/HostBackend.js';
import { PostLogin } from '../../Components/Admin/Functions/FetchHeaders.js';
/* document */
import { Header } from '../../Components/Admin/Document/Header.js';
import { Footer } from '../../Components/Public/Document/Footer.js';
import { MsgBackend } from '../../Components/Admin/Document/MsgBackend.js';
import { Email } from '../../Components/Admin/Form/Inputs/Email.js';
import { Password } from '../../Components/Admin/Form/Inputs/Password.js';

export const Login = () => {
    sessionStorage.removeItem('guest');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [msg, setMsg] = useState('');
    const backend = HostBackend();
    const handleLogin = async () => {
        const params = new URLSearchParams();
        params.append('email', email);
        params.append('password', password);
        const formEntries = Object.fromEntries(params.entries());
        const res = await fetch(`${backend}/auth/admin/login`, PostLogin(formEntries));
        const datas = await res.json();
        if (datas.token) {
            sessionStorage.setItem('token', datas.token);
            sessionStorage.setItem('refresh', datas.refresh);
            setMsg({
                css: 'bkg-success',
                msg: datas.msg,
                link: '/admin/entity/collection/attraction',
            });
        } else {
            setMsg({
                css: 'bkg-error',
                err: datas.msg,
            });
        }
        return msg;
    }
    return (
        <div className="login">
            <Header />
            <MsgBackend entity={''} msg={msg} />
            <div className="admin-form">
                <fieldset>
                    <legend>Login admin</legend>
                    <Email email={email} setEmail={setEmail} />
                    <Password password={password} setPassword={setPassword} />
                    <div className="block-buttons">
                        <button className="button" onClick={handleLogin}>Login</button>
                    </div>
                </fieldset>
            </div>
            <Footer />
        </div>
    )
}
